package com.nonopn.skywatcher.design.widgets.abslists

import eu.codlab.viewmodel.StateViewModel
import eu.codlab.viewmodel.launch
import kotlinx.coroutines.CoroutineScope

data class Section<H, E>(
    val header: H,
    val entities: List<E>
)

interface AbstractSectionListModelState<H, E> {
    val modelState: SectionListModelStateHolder<H, E>
}

abstract class AbstractSectionListModel<T : AbstractSectionListModelState<H, E>, H, E>(
    defaultState: T
) : StateViewModel<T>(defaultState) {
    abstract fun load()

    abstract fun filter(section: Section<H, E>, filteringString: String): Section<H, E>

    abstract fun onNewStateHolder(newHolder: SectionListModelStateHolder<H, E>)

    fun filter(filteringString: String) = launch {
        filter { filter(it, filteringString) }
    }

    fun filter(predicate: (Section<H, E>) -> Section<H, E>) = launch {
        val entities = states.value.modelState.objects
        val filtered = entities.map { predicate(it) }.filter { it.entities.isNotEmpty() }

        onNewStateHolder(
            states.value.modelState.copy(
                filtered = filtered,
                predicate = predicate
            )
        )
    }

    protected fun safeLaunch(block: suspend CoroutineScope.() -> Unit) = launch(
        onError = defaultOnError,
        run = block
    )

    private val defaultOnError: (throwable: Throwable) -> Unit = {
        println("error obtained")
        it.printStackTrace()

        onNewStateHolder(
            states.value.modelState.copy(
                state = ListModelState.ERROR
            )
        )
    }
}
